import React, { useEffect, useRef, useState } from "react";
import { FaCircleInfo } from "react-icons/fa6";

import confetti from "canvas-confetti";

const SpinnerWheel = ({
  spinerAddedData,
  handleSpinPointTest,
  pointsClaimed,
  handleCloseSpinnerClaim,
  setPointsClaimed,
  handleCloseSpinnerModal,
  spinerStatus,
  getSaveSpinReward,
  getProfile,
}) => {
  const canvasRef = useRef(null);
  const [list, setList] = useState([]);
  const [radius,setRadius] = useState(75);
  const [rotate, setRotate] = useState(245);
  const [easeOut, setEaseOut] = useState(0);
  const [angle, setAngle] = useState(0);
  const [top, setTop] = useState(null);
  const [offset, setOffset] = useState(null);
  const [result, setResult] = useState(null);

  // Sample data for demo
  useEffect(() => {
    if (spinerAddedData?.length > 0) {
      setList(spinerAddedData);
    } else {
      // Demo data
      setList([
        { Points: 100, CashAmount: null },
        { Points: 250, CashAmount: null },
        { Points: 500, CashAmount: null },
        { Points: 750, CashAmount: null },
        { Points: 1000, CashAmount: null },
        { Points: 50, CashAmount: null },
        { Points: 300, CashAmount: null },
        { Points: 150, CashAmount: null },
      ]);
    }
  }, [spinerAddedData]);

  useEffect(() => {
    if (list.length > 0) renderWheel();
  }, [list]);

  const topPosition = (num, angle) => {
    let topSpot = null;
    let degreesOff = null;
    if (num === 9) {
      topSpot = 7;
      degreesOff = Math.PI / 2 - angle * 2;
    } else if (num === 8) {
      topSpot = 6;
      degreesOff = 0;
    } else if (num <= 7 && num > 4) {
      topSpot = num - 1;
      degreesOff = Math.PI / 2 - angle;
    } else if (num === 4) {
      topSpot = num - 1;
      degreesOff = 0;
    } else if (num <= 3) {
      topSpot = num;
      degreesOff = Math.PI / 2;
    }
    setTop(topSpot - 1);
    setOffset(degreesOff);
  };

  const renderSector = (index, text, start, arc, colorIndex) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const x = canvas.width / 2;
    const y = canvas.height / 2;
    const startAngle = start;
    const endAngle = start + arc;
    const angle = index * arc;
    const baseSize = radius * 3.33;
    const textRadius = baseSize - 65;

    // Create gradient colors
    const colors = [
      ["#f44336", "#f44336"],
      ["#e91e63", "#e91e63"],
      ["#9c27b0", "#9c27b0"],
      ["#3f51b5", "#3f51b5"],
      ["#009688", "#009688"],
      ["#4caf50", "#4caf50"],
      ["#ffc107", "#ffc107"],
      ["#ff5722", "#ff5722"],
    ];

    const [color1, color2] = colors[colorIndex % colors.length];
    const gradient = ctx.createRadialGradient(x, y, 0, x, y, radius * 3);
    gradient.addColorStop(0, color1);
    gradient.addColorStop(1, color2);
    ctx.beginPath();
    ctx.arc(x, y, radius, startAngle, endAngle, false);
    ctx.lineWidth = radius * 3.5;
    ctx.strokeStyle = gradient;
    ctx.stroke();
    ctx.save();
    ctx.translate(
      baseSize + Math.cos(angle - arc / 2) * textRadius,
      baseSize + Math.sin(angle - arc / 2) * textRadius
    );
    ctx.rotate(angle - arc / 2 + Math.PI / 2);
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#ffffff";
    ctx.lineWidth = 3;
    ctx.strokeText(text, -ctx.measureText(text).width / 2, 5);
    ctx.fillText(text, -ctx.measureText(text).width / 2, 5);
    ctx.restore();
  };

  const renderWheel = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const numOptions = list.length;
    const arcSize = (2 * Math.PI) / numOptions;
    setAngle(arcSize);
    topPosition(numOptions, arcSize);
    let angle = 0;
    for (let i = 0; i < numOptions; i++) {
      const item = list[i];
      const text =
        item.CashAmount && item.CashAmount !== 0
          ? `₹${item.CashAmount}`
          : `${item.Points} PTS`;
      renderSector(i + 1, text, angle, arcSize, i);
      angle += arcSize;
    }
  };

  const [spinnerStop, setSpinnerStop] = useState(false);
  const segmentAngle = 360 / list.length;
  const handleSpin = async () => {
    setSpinnerStop(true);
    let data;
    if (handleSpinPointTest) {
      data = await handleSpinPointTest();
      if (data === null) return;
    } else {
      data = list[Math.floor(Math.random() * list.length)];
    }
    const targetPoints = data.points ?? data.Points;
    const targetCash = data.cashAmount ?? data.CashAmount;

    const index = list.findIndex(
      (item) =>
        (targetPoints !== undefined &&
          targetPoints !== null &&
          Number(item.Points) === Number(targetPoints)) ||
        (targetCash !== undefined &&
          targetCash !== null &&
          Number(item.CashAmount) === Number(targetCash))
    );

    if (index === -1) {
      return;
    }
    const spins = 5;
    const currentRotation = rotate;
    const targetSegmentAngle = index * segmentAngle;
    const angleToBringToZero = 360 - targetSegmentAngle;
    const totalRotation = 360 * spins + angleToBringToZero;
    setRotate(currentRotation + totalRotation);
    setEaseOut(3);
    setTimeout(() => {
      setResult(list[index]);
      setPointsClaimed(true);
      setSpinnerStop(false);
      setRotate(245);
      if (typeof getProfile === "function") {
        getProfile();
      }
      setEaseOut(0);
    }, 3000);
  };

  const handleCloseModal = () => {
    if (handleCloseSpinnerClaim) {
      handleCloseSpinnerClaim();
    } else {
      setPointsClaimed(false);
    }
    const canvas = document.getElementById("confetti-canvas");
    if (canvas) {
      canvas.remove();
    }
  };

  useEffect(() => {
    if (pointsClaimed) {
      launchConfetti();
    }
  }, [pointsClaimed]);

  const launchConfetti = () => {
    const duration = 2 * 1000;
    const animationEnd = Date.now() + duration;
    const defaults = {
      startVelocity: 30,
      spread: 360,
      ticks: 60,
      zIndex: 9999,
    };

    const canvas = document.getElementById("confetti-canvas");
    const myConfetti = confetti.create(canvas, {
      resize: true,
      useWorker: true,
    });
    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();
      if (timeLeft <= 0) {
        clearInterval(interval);
        return;
      }
      const particleCount = 50 * (timeLeft / duration);
      myConfetti({
        ...defaults,
        particleCount,
        origin: {
          x: Math.random(),

          y: Math.random() - 0.2,
        },
      });
    }, 250);
  };
  return (
    <>
     <button
            onClick={handleCloseSpinnerModal}
            className="cross-spiiner-modal-wheel"
            aria-label="Close"
          >
            &times;
          </button>
          <div className="prfsnl-spinner-wrapper">
      <div className="tooltip-container">
        <span className="info-icon">
          <FaCircleInfo className="info-icon-spinner"/>
        </span>
     
        <div className="tooltip-text">
          <ul>
            <li>
              You get a fixed number of free spins each session (spins reset
              after the timer runs out).
            </li>
            <li>Each spin gives you a chance to win points.</li>
            <li>If you win points, they’re added instantly to your balance.</li>
            <li>
              No spins left? Don’t worry — they refill automatically at reset
              time.
            </li>
            <li>Points are random, so every spin is exciting!</li>
            <li>
              Spin limits refresh automatically when a new session starts.
            </li>
            <li>Play fair — spins are for fun and points only.</li>
            <li>If an error happens, don’t worry — just refresh and retry.</li>
          </ul>
        </div>
      </div>
      <div className="prfsnl-spinner-container">
        <div>
          <h1 className="prfsnl-spinner-title"> Spin to Win!</h1>
            
        </div>
        <div>
          <p className="spinleft-wheel">
            You Have total {spinerStatus?.spinsRemaining} spin's left
          </p>

        </div>

        <div className="prfsnl-spinner-wheel-area">
          <div className="prfsnl-spinner-pointer"></div>
          <canvas
            ref={canvasRef}
            width="500"
            height="500"
            className="prfsnl-spinner-canvas"
            style={{
              transform: `rotate(${rotate}deg)`,
              transition: `transform ${easeOut}s ease-out`,
            }}
          
          />
          <button
            className="prfsnl-spinner-center-btn"
            onClick={handleSpin}
            disabled={spinnerStop}
          >
            SPIN
          </button>
        </div>
      </div>

      {/* Congratulations Modal */}
      {pointsClaimed && (
        <div className="prfsnl-modal-overlay">
          <div className="prfsnl-modal-content">
            <div className="prfsnl-modal-header">
              <button
                onClick={() => {
                  handleCloseModal();

                  handleCloseSpinnerModal();
                }}
                className="cross-spiiner-modal-wheel-inner"
                aria-label="Close"
              >
                &times;
              </button>

              <div className="congo_icon"> </div>

              <h2 className="prfsnl-modal-title">Congratulations!</h2>
            </div>

            <div className="prfsnl-modal-points">
              <p className="prfsnl-modal-points-text">You've won</p>

              <div className="prfsnl-modal-points-value">
                {result?.CashAmount && result?.CashAmount !== 0
                  ? `₹${result.CashAmount}`
                  : result?.Points}

                <span>
                  {result?.CashAmount && result?.CashAmount !== 0
                    ? "Cash"
                    : "Points"}
                </span>
              </div>
            </div>

            <h5 className="spinleft-wheel-new">
              {spinerStatus?.spinsRemaining} Spin's left
            </h5>

            <div className="prfsnl-modal-footer">
              {spinerStatus?.spinsRemaining === 0 ? (
                <button
                  className="auctionPrimaryButton"
                  onClick={() => {
                    handleCloseModal();

                    handleCloseSpinnerModal();

                    // getSaveSpinReward();
                  }}
                >
                  Close
                </button>
              ) : (
                <button
                  className="auctionPrimaryButton"
                  onClick={() => {
                    handleCloseModal();

                    getSaveSpinReward();
                  }}
                >
                  Spin Again
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
    </>
    
  );
};

export default SpinnerWheel;
